import { ComputedRef } from 'vue'

import { DailySoluition } from '@/domain/entities/dashboard/dailySolution'
import { LanguageStatistics } from '@/domain/entities/problem/languageStatistics'
import { StatisticsViewModel } from '@/presentation/viewmodels/dashboard/statisticsViewModel'

export class StatisticsPresenter {
  private viewModel: StatisticsViewModel

  constructor(viewModel: StatisticsViewModel) {
    this.viewModel = viewModel
  }

  get userLanguageStatisticsList(): ComputedRef<LanguageStatistics[]> {
    return this.viewModel.userLanguageStatisticsList
  }

  get userDailySolutionList(): ComputedRef<DailySoluition[][]> {
    return this.viewModel.userDailySolutionList
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<string | null> {
    return this.viewModel.error
  }

  async addUserStatistic(userId: string): Promise<void> {
    await this.viewModel.addUserStatistics(userId)
  }

  removeUserStatistics(): void {
    this.viewModel.removeUserStatistics()
  }

  removeTargetUsers(): void {
    this.viewModel.removeTargetUsers()
  }
}
